export default function() {

    $(document).ready(function() {

        $('.js-supporter-carousel:not(".slick-initialized")').slick({
            responsive: [{
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        infinite: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                        arrows: true,
                        centerMode: false
                    }
                }
            ],
            infinite: true,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 16000,
            fade: false,
            cssEase: 'ease-in',
            dots: true,
            lazyLoad: 'progressive',
            arrows: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Prev Arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next Arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
        });

        $('.js-accordionGroupCarousel:not(".slick-initialized")').slick({
            responsive: [{
                    breakpoint: 200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                        arrows: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true,
                        arrows: false
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true,
                        arrows: false
                    }
                },
                {
                    breakpoint: 1350,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true,
                        arrows: true
                    }
                }
            ],
            infinite: true,
            speed: 600,
            autoplay: false,
            autoplaySpeed: 8000,
            fade: false,
            cssEase: 'ease-in',
            dots: true,
            lazyLoad: 'progressive',
            arrows: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Prev Arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next Arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
        });

        $('.js-newsCarousel:not(".slick-initialized")').slick({
            responsive: [{
                    breakpoint: 200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                        arrows: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true,
                        arrows: false
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: true,
                        arrows: false
                    }
                },
                {
                    breakpoint: 1350,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: true,
                        arrows: true
                    }
                }
            ],
            infinite: true,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 8000,
            fade: false,
            cssEase: 'ease-in',
            dots: true,
            lazyLoad: 'progressive',
            arrows: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Prev Arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next Arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
        });

        $('.js-article-carousel:not(".slick-initialized")').slick({
            infinite: true,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 10000,
            fade: false,
            cssEase: 'ease-in',
            dots: false,
            lazyLoad: 'progressive',
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Prev Arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next Arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
        });


        $('[data-toggle="tab"]').on('click', function(ev){
            var targetId = $(this).attr('href');
            refreshSlick(targetId);
            $('.js-accordionGroupCarousel .card-expanded').removeClass('card-expanded').css({'height': 'auto'});
            $('.card-expander-content').css({'height': '0'});
        });

    });


    // on page load, default tab accordionGroupCarousel items height updated
    $('.js-accordionGroupCarousel:visible').on('init', function(event, slick){
        console.log("initialized");
        setTimeout(function(){
            updateAccordionGroupCardHeight('.js-accordionGroupCarousel:visible');
        },100)
    });

    // accordionGroupCarousel refresh - prevent 0 height items
    var lastRunRefreshSlick;
    function refreshSlick(targetId) {
        setTimeout(function(){

            var $carousel = $(targetId).find('.slick-initialized');

            if( $carousel.length > 0 && lastRunRefreshSlick != $carousel ) {
                lastRunRefreshSlick = $carousel;
                $carousel.addClass('slick-refreshed').slick("refresh");
                $carousel.slick("slickGoTo", 1);

                setTimeout(function(){
                    updateAccordionGroupCardHeight(targetId);
                },10)
            };
        }, 10)
    }

    // update accordionGroupCarousel item min height - make items equal hight
    function updateAccordionGroupCardHeight(targetId) {
        var accordionGroupCardHeight = 0;
        $(targetId + ' .accordionGroup-card').each(function(){
            $(this).css({'min-height': '218px'}); // card default height
            var cardHeight = $(this).outerHeight();
            if ( cardHeight > accordionGroupCardHeight ) {
                accordionGroupCardHeight = cardHeight;
            };
        });
        $(targetId + ' .accordionGroup-card').css({'min-height': accordionGroupCardHeight});
    }
}

